// extracted by mini-css-extract-plugin
module.exports = {"title":"components-ui-userinfo-title","subtitle":"components-ui-userinfo-subtitle"};